import { Component, ElementRef, OnInit } from '@angular/core';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'fury-view-copay-fee',
  templateUrl: './view-copay-fee.component.html',
  styleUrls: ['./view-copay-fee.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class ViewCopayFeeComponent implements OnInit {
  copayFeeData!:any;
  isLoading : boolean = true;
  constructor(
    private apiService: ApiService,
  ) { }

  ngOnInit(): void {
    this.getCopayFeeText();
  }
  getCopayFeeText(){
    this.isLoading = true;
    this.apiService.get('admin/settings/copay-fee-text/get-copay-fee-text-settings').subscribe((res: any)=>{
      if(res?.body){
        this.isLoading = false;
        this.copayFeeData = res?.body?.copayFeeText;
      }
    }, err =>{
      if(err){
        this.isLoading = false;
      }
    })
  }

}
